// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2iToO","title":"ClientInsurance_title__O0GMD","itemText":"ClientInsurance_itemText__2tx5g"};